/**
 * The shape of a control in the palette's filter row: a scope pill, or stock mode's location chip. One
 * spelling, so the two read as the same kind of control and a change to one reaches both.
 */
const PALETTE_PILL_CLASS =
  'inline-flex items-center gap-2 rounded-lg border px-3 py-1 text-sm font-medium transition-colors duration-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500'

/** A scope pill that is switched on. */
const PALETTE_PILL_ACTIVE_CLASS = 'border-primary-200 bg-primary-50 text-primary-700'

/** A pill that is not switched on, or the location chip, which is never switched. */
const PALETTE_PILL_IDLE_CLASS =
  'border-surface-200 bg-surface-0 text-surface-700 [@media(hover:hover)]:hover:bg-surface-100'

export { PALETTE_PILL_ACTIVE_CLASS, PALETTE_PILL_CLASS, PALETTE_PILL_IDLE_CLASS }
